<template>
    <v-form ref="postUploadForm" v-model="postValid" lazy-validation>
        <!-- Post title -->
        <div>
            <v-text-field ref="postTitle" label="Title" color="grey" v-model="postTitle" :rules="[genericRules.requiredRule]" required @blur="resetField($refs.postTitle)" outlined background-color="primary" hide-details="auto" tile></v-text-field>
        </div>
        <!-- Photo uploader -->
        <div class="mt-5">
            <widget-media-uploader :photos="photos" @filesAdded="managePhotos" @deletePhoto="deletePhoto" @updatePhoto="updatePhoto" />
        </div>
        <!-- Post description -->
        <div class="mt-5">
            <!-- <v-textarea ref="postDescription" label="Description" color="grey" v-model="postDescription" outlined background-color="primary" tile></v-textarea> -->
            <wysiwig-editor ref="postDescription" v-model="postDescription" placeholder="Add description"></wysiwig-editor>
        </div>
        <!-- User tags -->
        <!-- <div class="mt-5">
            <v-autocomplete id="user-tag" v-model="tags" :items="users" filled chips background-color="primary" color="grey" label="Tag Peoples" item-text="name" item-value="name" outlined multiple clearable clear-icon="mdi-refresh" hide-selected hide-details>
                <template v-slot:selection="data">
                    <v-chip color="grey darken-3" text-color="white" v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeTag(data.item)">
                        <v-avatar left color="green">
                            <span>{{ data.item.name[0] }}</span>
                        </v-avatar>
                        {{ data.item.name }}
                    </v-chip>
                </template>
                <template v-slot:item="data" color="grey">
                    <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                        <v-list-item-avatar>
                            <v-avatar color="green">
                                <span>{{ data.item.name[0] }}</span>
                            </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                        </v-list-item-content>
                    </template>
                </template>
            </v-autocomplete>
        </div> -->
        <!-- Submit buttom -->
        <div class="mt-5" v-if="isDesktop">
            <v-btn color="blue" @click="sendPost" block class="text-capitalize white--text" 
            :loading="loading"
            :disabled="loading">
                Post
            </v-btn>
        </div>
    </v-form>
</template>
<script>
import formMixins from "@/mixins/mixin-forms"
import postCreateMixins from "@/mixins/mixin-post-create"
import wysiwigEditor from "@/components/editor/wysiwyg-editor.vue"
export default {
    components: {
        wysiwigEditor
    },
    mixins: [formMixins, postCreateMixins],
    props: ['users', 'photos', 'loading']
}
</script>